import React, { useContext } from 'react';
import { makeId } from '../../../utilities/idComponent';
import TextField from '../../Forms/TextField/TextField';
import { DropdownContext } from './DropdownContext';

export type DropdownInputProps = {
  value?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  onClose: () => void;
  onOpen: () => void;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

const DropdownInput = ({
  value,
  onChange,
  onClose,
  onOpen,
  children,
  id,
  ...props
}: DropdownInputProps) => {
  const { inputRef, hideMenu, showMenu } = useContext(DropdownContext);

  const onBlur = () => {
    setTimeout(hideMenu, 100);
    onClose();
  };

  const onFocus = () => {
    setTimeout(showMenu, 100);
    onOpen();
  };

  return (
    <div ref={inputRef} id={makeId('list', undefined, id)}>
      <TextField
        {...props}
        value={value}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
        rightIcon={children}
      />
    </div>
  );
};

export default DropdownInput;
